module.exports = __webpack_public_path__ + "static/media/23.21f00e7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/23.jpg
// module id = 392
// module chunks = 0